define('app/views/fix_sidebar',['app/setup','jquery.sticky-sidebar'], function(takhfifan,jStickySidebar) {
  takhfifan.fixSidebar = Backbone.View.extend({
    initialize: function(options) {
      options = _.extend({
        topSpacing: 50,
        bottomSpacing: 0
      }, options);
      var _this = this;
      this.$sticky = this.$el.stickySidebar(options);
      takhfifan.eventHub.on('sticky:update', _.debounce(function() {
        _this.$sticky.stickySidebar('updateSticky');
      }),500);
      setTimeout(function(){ takhfifan.eventHub.trigger('sticky:update'); }, 2000);
    }
  })
});
